import { createHash } from 'crypto';

const FILE_HASH_CHUNK_SIZE_BYTES = 4 * 1024 * 1024;

export async function calculateSha256Hash(
  data: ArrayBuffer | Uint8Array,
): Promise<string> {
  const buffer =
    data instanceof ArrayBuffer ? data : new Uint8Array(data).buffer;
  const hashBuffer = await globalThis.crypto.subtle.digest(
    'SHA-256',
    buffer as ArrayBuffer,
  );

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return hashHex;
}

export async function calculateFileHash(
  file: File | Blob,
  onProgress?: (percent: number) => void,
): Promise<string> {
  const hash = createHash('sha256');

  for (
    let offset = 0;
    offset < file.size;
    offset += FILE_HASH_CHUNK_SIZE_BYTES
  ) {
    const end = Math.min(offset + FILE_HASH_CHUNK_SIZE_BYTES, file.size);
    const chunk = new Uint8Array(await file.slice(offset, end).arrayBuffer());
    hash.update(chunk);
    onProgress?.(Math.round((end / file.size) * 100));
  }

  if (file.size === 0) {
    onProgress?.(100);
  }

  return hash.digest('hex');
}

export async function calculateJsonHash(data: unknown): Promise<string> {
  const jsonString = JSON.stringify(data);
  const encoder = new TextEncoder();
  const buffer = encoder.encode(jsonString);
  return calculateSha256Hash(buffer);
}
